import React, {Component} from 'react';
import './AuthLogo.css';

export default class AuthLogo extends Component {
    render() {
        return (
            <a className={"AuthLogo"} href={"https://www.rememberme.nl"} title={"RememberMe.nl"}>
                <img className={"AuthLogo__img"} src={"https://static.rememberme.nl/min/images/RME.nl_logo_RGB.png"}
                     alt={"RememberMe.nl"}/>
            </a>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Auth/AuthLogo.js